import { ReoCarousel as ReolinkCarousel }  from '@reolink-deps/reolink-web_components.basic';
import { ReoCarousel as CamovueCarousel }  from '@camovue-deps/reolink-web_components.basic';
import type { ICarouselProps as IReolinkCarouselProps }  from '@reolink-deps/reolink-web_components.basic';
import type { ICarouselProps as ICamovueCarouselProps }  from '@camovue-deps/reolink-web_components.basic';

const Carousel = __MERCHANT__ === 'reolink' ? ReolinkCarousel : CamovueCarousel;

export type ICarouselProps = IReolinkCarouselProps | ICamovueCarouselProps;
export default Carousel;
